import {
  AutoComplete,
  FormCheckBox,
  FormInput,
  ISelectType,
  useFormContext,
} from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import MainApi from "../../../../../../services/mainApi.service";
import { AutomationExecutionSelect } from "./AutomationExecutionSelect/AutomationExecutionSelect";
import { RotationModeSelect } from "./RotationModeSelect/RotationModeSelect";
import { SoftwareSelect } from "./SoftwareSelect/SoftwareSelect";
import { CopyFilesFields } from "./CopyFilesFields/CopyFilesFields";
import { TFileIntegrationForm } from "../fileIntegrationSchema";
import { useWatch } from "react-hook-form";

const translationPath = "page.4uBus.uBusAutomationRobot.";

const GENERIC_ROUTE = process.env.REACT_APP_MAIN + "/api/v1/Generic/";
const genericService = new MainApi<ISelectType>(GENERIC_ROUTE);

export const RobotRules = memo(() => {
  const { t } = useTranslation();
  const { control } = useFormContext<TFileIntegrationForm>();
  const currentGeneratePdfWithImages = useWatch({
    name: "generatePdfWithImages",
    control,
  });

  return (
    <>
      <SoftwareSelect />

      <Grid item xs={12} sm={6}>
        <AutomationExecutionSelect />
      </Grid>
      <Grid item xs={12} sm={4}>
        <AutoComplete
          params={{ Identifier: "IntegrationAttribute" }}
          name="integrationAttribute"
          label={t(translationPath + "integration_attribute")}
          getOptionLabel={(option) => option.name}
          size="small"
          fullWidth
          request={genericService.list}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <FormInput
          name="minutes"
          label={t(translationPath + "minutes")}
          size="small"
          fullWidth
          rows={4}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <FormInput
          name="internalProcedureIntegrationId"
          label={t(translationPath + "internal_procedure_integration_id")}
          size="small"
          fullWidth
          rows={4}
        />
      </Grid>
      <Grid item xs={12} sm={12}>
        <FormInput
          name="medicalCertificateContent"
          label={t(translationPath + "medical_certificate_content")}
          multiline
          fullWidth
          minRows={3}
        />
      </Grid>
      <Grid item xs={12} sm={5}>
        <FormCheckBox
          name="insertImageAsAttachment"
          label={`${t(translationPath + "insert_image_as_attachment")}`}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <FormCheckBox
          name="rotateImages"
          label={`${t(translationPath + "rotate_images")}`}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <RotationModeSelect />
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormCheckBox
          name="physicianWillReport"
          label={`${t(translationPath + "physician_will_report")}`}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormInput
          name="minutesToGroupPdf"
          label={t(translationPath + "minutes_to_group_pdf")}
          size="small"
          fullWidth
          rows={4}
        />
      </Grid>
      <Grid item xs={12} sm={currentGeneratePdfWithImages ? 4 : 12}>
        <FormCheckBox
          name="generatePdfWithImages"
          label={`${t(translationPath + "generate_pdf_with_images")}`}
        />
      </Grid>
      {currentGeneratePdfWithImages && (
        <>
          <Grid item xs={12} sm={4}>
            <FormCheckBox
              name="insertReportTestPdf"
              label={`${t(translationPath + "insert_report_test_pdf")}`}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <FormCheckBox
              name="insertReportTestPdfAsImage"
              label={`${t(
                translationPath + "insert_report_test_pdf_as_image"
              )}`}
            />
          </Grid>
        </>
      )}
      <CopyFilesFields />
    </>
  );
});
